import React from "react";
import Contact from "../components/Contact";
import ServiceHeader from "../components/ServiceHeader";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import contact_img from "../static/img/service_header.jpg";
function ContactUsPage() {
  return (
    <>
      <Nav />
      <ServiceHeader 
        image={contact_img}
        title={"Contact Us"}
        description={"We are here to help you. Reach out to us for any queries."}
      />
      <Contact />
      <Footer/>
    </>
  );
}
export default ContactUsPage;
